<template>
  <div class="postTask" v-loading="Loading" style="overflow: hidden">
    
    
    <!--左上。任务信息-->
    <el-row class="common-box" style="width: 49%">
      
      <div class="common-box-btn clearfix">
        <h2 class="floatl">任务信息</h2>
      </div>
      
      <el-form ref="F_taskInfo" :model="taskInfo" label-width="80px" style="padding: 13px 15px 21px 15px"
               class="F_taskInfo">
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <span class="formLabel"><span class="required">* </span>任务标题</span>
              <el-input v-model="taskInfo.title" size="mini" placeholder="请输入任务标题..." :maxlength="30" clearable
                        class="wid60"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <span class="formLabel"><span class="required">* </span>任务类型</span>
              <el-select v-model="taskInfo.type" size="mini" placeholder="请选择任务类型..." :clearable="true" clearable
                         class="wid60">
                <el-option
                    v-for="item in taskInfo.options.type"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item>
            <span class="formLabel"><span class="required">* </span>任务参与时间</span>
            <el-date-picker
                v-model="taskInfo.during.start"
                type="date"
                size="mini"
                format="yyyy 年 MM 月 dd 日"
                placeholder="任务开始时间"
                style="width: 27.8%"
            >
              <!--value-format="yyyy-MM-dd"-->
            </el-date-picker>
            <span style="display:inline-block;width: 10%;text-align: center">—</span>
            <el-date-picker
                v-model="taskInfo.during.end"
                type="date"
                size="mini"
                format="yyyy 年 MM 月 dd 日"
                placeholder="任务结束时间"
                style="width: 30%"
            >
              <!--value-format="yyyy-MM-dd"-->
            </el-date-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <span class="formLabel"><span class="required">* </span>任务审核时间</span>
              <el-select v-model="taskInfo.auditTime" size="mini" placeholder="请选择..." clearable
                         class="wid60">
                <el-option
                    v-for="item in taskInfo.options.auditTime"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <span class="formLabel"><span class="required">* </span>完成时限</span>
              <el-select v-model="taskInfo.deadline" size="mini" placeholder="请选择..." clearable
                         class="wid60">
                <el-option
                    v-for="item in taskInfo.options.deadline"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <span class="formLabel"><span class="required">* </span>任务描述</span>
          <el-input type="textarea" :rows="4" :maxlength="300"
                    v-model="taskInfo.details"
                    size="mini"
                    style="width:77.5%;margin:8px 0 7px 0" placeholder="请描述是否有社保相关福利待遇情况..."
          ></el-input>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <span class="formLabel"><span class="required">* </span>任务预算</span>
              <el-input v-model="taskInfo.budget" size="mini" placeholder="请输入预算金额..." :maxlength="30" clearable
                        class="wid60">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    
    
    <!--右上。文件上传-->
    
    <el-row class="common-box" style="width: 49%;margin-left: 2%">
      
      <div class="common-box-btn clearfix">
        <h2 class="floatl">文件上传</h2>
      </div>
      
      <el-form ref="F_taskFile" :model="taskFile" label-width="80px" style="padding: 13px 15px" class="F_taskFile">
        <el-row style="background: #f8f8f8">
          <el-col :span="12">
            <el-form-item>
              <span class="formLabel"><span class="required">* </span>上传类型</span>
              <el-select v-model="taskFile.type" size="mini" placeholder="请选择..." :clearable="true" clearable
                         class="wid60">
                <el-option
                    v-for="item in taskFile.options.type"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="margin: 11px 0">
            <el-button type="primary" round size="mini" @click="addFile" icon="el-icon-plus"
                       style="margin-right: 5%;float: right">添加
            </el-button>
          </el-col>
        </el-row>
        <div class="fileList" id="fileList">
          <el-row style="background: #f8f8f8;margin-top: 8px;padding-right:2.5%"
                  v-for="(item,index) in taskFile.fileList"
                  :key="index" @click.native="editing(index)">
            <el-row>
              <span class="formLabel"><span class="required">* </span>上传类型</span>
              <b class="formLabel" style="text-align: left">{{item.type}}</b>
              <el-button type="primary" icon="el-icon-close" @click="deleteFile(index)" circle size="mini "
                         style="float: right;margin:13px 0;padding: 4px;"></el-button>
            </el-row>
            <el-row style="margin-left: 5%">
              <el-col :span="14" v-if="item.editing">
                <div>
                  <h1 style="font-size: 20px">请上传{{item.type}}</h1>
                  <p v-if="item.type == '图片'">图片必须清晰，图片必须清晰，图片必须清晰，图片必须清晰，图片必须清晰，图片必须清晰，图片必须清晰，图片必须清晰，图片必须清晰，</p>
                  <p v-else-if="item.type == '视频'">视频必须清晰，视频必须清晰，视频必须清晰，视频必须清晰，视频必须清晰，视频必须清晰，视频必须清晰，视频必须清晰，视频必须清晰，</p>
                  <p v-else>音频必须清晰，音频必须清晰，音频必须清晰，音频必须清晰，音频必须清晰，音频必须清晰，音频必须清晰，音频必须清晰，音频必须清晰，</p>
                </div>
              </el-col>
              <el-col :span="14" v-else style="margin-bottom: 5px">
                <div>
                  <h1 style="font-size: 20px">{{item.type}}描述</h1>
                  <el-input type="textarea" :rows="4" :maxlength="300"
                            v-model="item.details"
                            size="mini"
                            style="width:100%;margin:8px 0 7px 0" placeholder="任务要求...">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="10">
                <el-upload
                    class="avatar-uploader"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :show-file-list="false"
                    :on-success="uploadSucc"
                    :before-upload="checkUpload('pic')">
                  <img v-if="item.picUrl" :src="item.picUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-col>
            </el-row>
            <el-row style="margin-left: 5%" v-if="item.editing">
              <el-input type="textarea" :rows="3" :maxlength="300"
                        v-model="item.details"
                        size="mini"
                        style="width:100%;margin:8px 0 7px 0" placeholder="请描述任务要求...">
              </el-input>
            </el-row>
          </el-row>
        </div>
      </el-form>
    </el-row>
    
    
    <!--中间：任务参与范围-->
    <el-row class="common-box">
      
      <div class="common-box-btn clearfix">
        <h2 class="floatl">任务参与范围</h2>
      </div>
      
      <el-form ref="F_taskScope" :model="taskScope" label-width="80px" style="padding: 13px 15px"
               class="F_taskScope">
        <el-form-item>
          <span class="formLabel">门店</span>
          <!--暂时不需要选择地区按钮，记得删除checkArea方法-->
          <!--<el-button type="success" round size="mini" @click.native="checkArea">选择地区</el-button>-->
          <el-button type="success" round size="mini" @click.native="checkShop" class="clickSign">选择门店</el-button>
        </el-form-item>
        <el-form-item>
          <el-row>
            <el-col style="width: 112px">
              <span class="formLabel">已选门店</span>
            </el-col>
            <el-col style="width:90%">
              <span class="already-btn" v-for="(item,index) in taskScope.ckeckedStores" :key="index">
                {{item.name}}&nbsp;&nbsp;&nbsp;{{item.num}}人&nbsp;&nbsp;&nbsp;￥{{item.salary}}
                <span class="remove-btn pointer" @click="deleteckeckedStore(index)"></span>
              </span>
            </el-col>
          </el-row>
        
        </el-form-item>
        <el-form-item>
          <el-col style="width: 112px">
            <span class="formLabel">门店距离</span>
          </el-col>
          <el-col style="width:90%">
            <el-radio-group v-model="taskScope.storesDistance" size="small">
              <el-radio-button
                  :label="item"
                  v-for="(item,index) in taskScope.distanceList"
                  :key="index" border
                  class="elRadioB">
              </el-radio-button>
            </el-radio-group>
          </el-col>
        
        </el-form-item>
      </el-form>
    </el-row>
    
    
    <!--下方-可见范围-->
    <el-row class="common-box">
      
      <div class="common-box-btn clearfix">
        <h2 class="floatl">可见范围设定</h2>
        <div>
          <el-checkbox label="在岗时任务不可见" v-model="visibleScope.noTaskOnDuty"></el-checkbox>
        </div>
      </div>
      
      <el-form ref="F_visibleScope" :model="visibleScope" label-width="80px" style="padding: 13px 15px"
               class="F_visibleScope">
        <el-col :span="6" style="margin-bottom:15px">
          <el-form-item>
            <span class="formLabel" style="text-align: left;width:35px">星级</span>
            <!-- <el-input v-model="jobInformation.starRating"  size="mini" class="rangeSetting"  placeholder="请输入任务名称..."></el-input> -->
            
            <el-select v-model="visibleScope.star" size="mini" style="width: 40%"
                       placeholder="请选择...">
              <el-option
                  v-for="item in visibleScope.starOptions"
                  :key="item.id"
                  :label="item.rankName"
                  :value="item.rankName">
              </el-option>
            </el-select>
            <span
                style="width:90px;text-align: left;font-size: 14px;color: #606266;position:relative;left:5px">级别级以上</span>
          </el-form-item>
        </el-col>
        
        <el-col :span="5" style="margin-bottom:15px">
          <el-form-item>
            <span class="formLabel pad20">信用分值下限</span>
            <el-input v-model.number="visibleScope.crescoreMin"
                      size="mini"
                      placeholder="分"
                      style="width: 35%">
            </el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="4" style="margin-bottom:15px">
          <el-form-item>
            <span class="formLabel" style="text-align: left;width:35px">性别</span>
            <!-- <el-input v-model="jobInformation.starRating"  size="mini" class="rangeSetting"  placeholder="请输入任务名称..."></el-input> -->
            
            <el-select v-model="visibleScope.sex" size="mini"
                       placeholder="请选择..." style="width: 60%">
              <el-option
                  v-for="item in visibleScope.sexOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="9" style="margin-bottom:15px">
          <el-form-item>
            <span class="formLabel">角色</span>
            <el-checkbox-group v-model="visibleScope.role"
                               style="width:70%;display:inline-block">
              <el-checkbox label="认证促销员"></el-checkbox>
              <el-checkbox label="未认证促销员" style="margin-left: 20px"></el-checkbox>
              <el-checkbox label="督导" style="margin-left: 20px"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    
    
    <!--最下-发布 & 预览-->
    <el-row style="margin-bottom: 15px;float: left;width: 100%">
      <div class="btns">
        <el-button type="text" @click="viewTask">预览任务</el-button>
        <el-button type="primary" class="sureBtn" @click="postTask">发布</el-button>
      </div>
    </el-row>
    
    
    <!--选择门店dialog-->
    <el-dialog title="选择门店弹框"
               :visible.sync="storesDialog.show"
               width="30%">
      <span>选择门店弹框,这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="storesDialog.show = false">取 消</el-button>
        <el-button type="primary" @click="storesDialog.show = false">确 定</el-button>
      </span>
    </el-dialog>
  
  
    <!--预览岗位dialog-->
    <el-dialog title="预览岗位弹框"
               :visible.sync="viewTaskDialog.show"
               width="30%">
      <span>预览岗位弹框,这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="viewTaskDialog.show = false">取 消</el-button>
        <el-button type="primary" @click="viewTaskDialog.show = false">确 定</el-button>
      </span>
    </el-dialog>
    
  </div>
</template>

<script>
  export default {
    name: "post-taskCenter",
    mounted() {},
    data() {
      return {
        Loading: false,//全局loading
        taskInfo: {//左上任务信息的数据
          title: '',//任务标题
          type: '',//任务类型
          during: {//任务参与时间
            start: '',
            end: ''
          },
          auditTime: '',//任务审核时间
          details: '',//任务详情描述
          budget: '',//预算金额
          deadline: '',//完成时限
          options: {//本div所有的选项框的选项
            type: [//任务类型
              {label: '类型一', value: 1},
              {label: '类型二', value: 2},
              {label: '类型三', value: 3},
              {label: '类型四', value: 4},
            ],
            auditTime: [//任务审核时间
              {label: '时间一', value: 1},
              {label: '时间二', value: 2},
              {label: '时间三', value: 3},
              {label: '时间四', value: 4},
            ],
            deadline: [//完成时限
              {label: '时限一', value: 1},
              {label: '时限二', value: 2},
              {label: '时限三', value: 3},
              {label: '时限四', value: 4},
            ],
          },
        },
        taskFile: {//右上文件上传窗口
          type: '',//上传类型
          options: {//本div所有的选项框的选项
            type: [//上传类型
              {label: '图片', value: 1},
              {label: '视频', value: 2},
              {label: '音频', value: 3},
            ],
          },
          fileList: [//上传上来的列表
            {
              type: '图片',
              picUrl: '',
              details: '',
              editing: false,
            },
            {
              type: '视频',
              videoUrl: '',
              details: '',
              editing: false,
            },
            {
              type: '音频',
              AudioUrl: '',
              details: '',
              editing: false,
            },
          ],
        },
        taskScope: {//中间：任务参与范围
          ckeckedStores: [//已选择的门店信息
            {
              name: '吉林省',
              num: 1,
              salary: 10,
            },
            {
              name: '沈阳市',
              num: 1,
              salary: 10,
            },
            {
              name: '门店名称门店名称',
              num: 1,
              salary: 10,
            },
            {
              name: '门店名称门店名称',
              num: 100,
              salary: 1000,
            },
            {
              name: '门店名称门店名称',
              num: 1,
              salary: 99999,
            },
          ],
          storesDistance: '',//门店距离选择结果
          distanceList: ['不限', '<1 Km', '<2 Km', '<3 Km', '<5 Km', '<10 Km'],//门店距离选项
        },
        visibleScope: {//下方可见范围设定
          noTaskOnDuty: '',//在岗时任务不可见
          star: '',//星级
          starOptions: [//星级选项
            {id: 1, rankName: '一级'},
            {id: 2, rankName: '二级'},
            {id: 3, rankName: '三级'},
            {id: 4, rankName: '四级'},
            {id: 5, rankName: '五级'},
            {id: 6, rankName: '六级'},
          ],
          crescoreMin: '',//信用分值下限
          sex: '',//性别
          sexOptions: [
            {id: 1, name: '不限'},
            {id: 2, name: '男'},
            {id: 3, name: '女'}
          ],
          role: [],//角色
        },
        storesDialog:{//选择门店弹框
          show:false,
          
        },
        viewTaskDialog:{//预览岗位弹框
          show:false,
          
        }
      }
    },
    methods: {
      //上传文件-清空编辑状态
      removeEditing() {
        this.taskFile.fileList.map((item, index) => {
          item.editing = false;
        })
      },
      //上传文件-切换展开状态
      editing(index) {
        //点自己且已展开，则关闭。其他所有情况，先清空再展开当前
        if (this.taskFile.fileList[index].editing) {
          this.taskFile.fileList[index].editing = false
        } else {
          this.removeEditing()
          this.taskFile.fileList[index].editing = true
        }
      },
      //上传文件-添加文件
      addFile() {
        //先清空编辑状态
        this.removeEditing();

        if (this.taskFile.type) {
          let type
          if (this.taskFile.type == 1) {
            // alert('添加图片类型')
            type = '图片'
          } else if (this.taskFile.type == 2) {
            // alert('添加视频类型')
            type = '视频'
          } else if (this.taskFile.type == 3) {
            // alert('添加音频类型')
            type = '音频'
          }
          this.taskFile.fileList.unshift({
            type: type,
            picUrl: '',
            videoUrl: '',
            AudioUrl: '',
            details: '',
            editing: true,
          })
          //滑块自动置顶
          document.getElementById('fileList').scrollTo(0, 0)
        } else {
          alert('未选择类型')
        }

        //再清空选择的类型
        this.taskFile.type = ''
      },
      //上传文件-删除文件
      deleteFile(index) {
        alert('删除第' + (index + 1) + '条数据')
        this.taskFile.fileList.splice(index, 1)
      },
      //上传文件-检查文件
      checkUpload(type) {

      },
      //上传文件-成功回调
      uploadSucc(res, file) {
        this.taskFile.fileList[0] = URL.createObjectURL(file.raw);
        this.$notify({
          title: '成功',
          type: 'success',
        })
      },
      //任务范围-点击选择地区按钮，记得删除
      checkArea() {
        alert('选择地区')
      },
      //任务范围-点击选择门店按钮
      checkShop() {
        this.storesDialog.show = true;
      },
      //任务范围-删除已选的数据
      deleteckeckedStore(index) {
        alert('删除第 ' + (index + 1) + ' 条数据')
        this.taskScope.ckeckedStores.splice(index,1)
      },
      viewTask() {
        this.storesDialog.show = true;
      },
      postTask() {
        // check
          // 是否空，日期范围，预算格式，文件添加了必须有数据
        alert('发布任务')
        //成功或错误提示
      },
    },
  }
</script>

<style scoped lang="scss">
  
  .common-box {
    float: left;
    .common-box-btn {
      padding: 7px 20px;
    }
  }
  /*上传文件*/
  .F_taskFile {
    .fileList {
      height: 259px;
      /*overflow: scroll;*/
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
  
  /*任务范围-门店*/
  .clickSign {
    background-color: #81bc82;
    padding: 3px 15px;
    border-radius: 30px;
    color: white;
    font-size: 14px;
  }
  
  /*任务范围-已选门店*/
  .already-btn {
    background-color: #8299dc;
    color: white;
    padding: 3px 10px;
    border-radius: 30px;
    margin-right: 10px;
    margin-bottom: 10px;
    display: inline-block;
    line-height: 24px;
    font-size: 14px;
  }
  
  /*任务范围-已选门店*/
  .remove-btn {
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-left: 20px;
    margin-top: -2px;
    background: url(../../../common/images/shan2.png) no-repeat center;
  }
  
  /*距离-按钮*/
  .elRadioB {
    margin-left: 10px;
  }
  
  /*最下-发布 & 预览任务*/
  .btns {
    width: 200px;
    margin: 0 auto;
    .sureBtn {
      width: 80px;
      height: 30px;
      line-height: 6px;
      background: #2c2b79;
      border: none;
      padding: 0;
      margin-left: 35px
    }
  }

</style>


// WEBPACK FOOTER //
// src/views/taskCenter/postTask/postTask.vue